<script setup>
import { provide, watch, computed, inject } from 'vue';
import { useForm } from 'vee-validate';

import { 
	__, 
	registrationInfo, 
	formFragmentValues, 
	setFormFragmentValues, 
	getFormValuesFromLocalStorage, 
	updateURL, 
	setFormValues, 
	getCookie, 
	finishRegistrationIsSuccess,
	handleLeadQuery,
	clearDash,
	sendCellularData
} from '@/utils';
import { getValidationShema } from '@/validationShema'
const { setActiveStep, 
	nextStep, 
	currStep,
	activeStep, 
	showSuccessPage, 
	hideRegistrationForm, 
	finishRegistrationLoader, 
	failRegistration, 
	failPayment,
	setValidStep,
	handleRegistrationData,
	progressUpdate
} = inject('step');

const validationSchema = getValidationShema();
const localStorageValues = getFormValuesFromLocalStorage();
const localValues = formFragmentValues();

const currentSchema = computed(() => {
	return validationSchema[activeStep.value - 1];
});

const { values, handleSubmit, defineField, resetForm, validate, errors } = useForm({
	validationSchema: currentSchema,
	keepValuesOnUnmount: true,
	initialValues: localStorageValues,
});

handleLeadQuery();

const onSubmit = handleSubmit((values) => {
	const formStep = formFragmentValues();
	const activeStep = formStep.activeStep;
	const lastStep = formStep.lastStep;

	setValidStep(true);

	getLeadId();

	if (activeStep === lastStep) {
		finishRegistration();
	} else {
		updateURL(`#step${nextStep()}`)
	}
	setActiveStep(nextStep());
}, (errors) => {
	setValidStep(false);
});

const getLeadId = () => {
	let current_step = "step_" + (nextStep());
	let previous_step = "step_" + currStep();

	progressUpdate.value = true;

	const savedFields = getFormValuesFromLocalStorage();
	const clientType = savedFields.activeTab === 'Business Client' ? 'company' : 'subscriber';

	const leadId = sessionStorage.getItem('lead_id');


	const newData = {
		"current_step": current_step,
		"previous_step": previous_step,
		"registration_id": localValues.registrationID,
		"first_name": savedFields[`${clientType}FirstName`],
		"last_name": savedFields[`${clientType}LastName`],
		"phone_office": clearDash(savedFields[`${clientType}Phone`]),
		"email": savedFields[`${clientType}Email`],
		"lead_id": leadId,
		"utm_campaign": getCookie('utm_campaign') ? getCookie('utm_campaign') : '',
		"utm_medium": getCookie('utm_medium') ? getCookie('utm_medium') : '',
		"utm_source": getCookie('utm_source') ? getCookie('utm_source') : '',
		"utm_term": getCookie('utm_term') ? getCookie('utm_term') : '',
		"utm_content": getCookie('utm_content') ? getCookie('utm_content') : '',
	}

	const newDataJsonString = JSON.stringify(newData);
 
	fetch(ajax_object.ajax_url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: `action=update_progress&userData=${newDataJsonString}`, 
	})
		.then(response => response.json())
		.then(data => {

			const parsedData = JSON.parse(data.data);
			const lead_id = parsedData.response.lead_id
			if (lead_id) {
				sessionStorage.setItem('lead_id', lead_id)
			}
		})
		.catch(error => console.error('Error:', error))
		.finally(() => {
			progressUpdate.value = false;
        });
}

const finishRegistration = async () => {
    const savedFields = getFormValuesFromLocalStorage();

    try {
		const leadId = sessionStorage.getItem('lead_id');
        const formData = await registrationInfo(savedFields, leadId);

        const formDataJsonString = JSON.stringify(formData);
        finishRegistrationLoader.value = true;

        const response = await fetch(ajax_object.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `action=finish_registration&formData=${formDataJsonString}`,
        });
 
        const data = await response.json();
        const registrationData = JSON.parse(data.data);
		

		if (finishRegistrationIsSuccess(registrationData)) {
			sendCellularData();
			savedFields.registrationData = registrationData.response;
			setFormValues(savedFields)
			sessionStorage.removeItem('lead_id');
	
			showSuccessPage.value = true;
			hideRegistrationForm.value = true;

			setFormFragmentValues({
				showSuccessPage: true,
				hideRegistrationForm: true,
			});

			handleRegistrationData(registrationData.response)
			updateURL(`#success`)
		}else{
			failRegistration.value = true;
		}
        
    } catch (error) {
        console.error('Error:', error);
        failRegistration.value = true;
    } finally {
       finishRegistrationLoader.value = false;
    }
};

const checkForSuccessPayment = () => {
	const currentUrl = window.location.href;
	const formStep = formFragmentValues();
	const activeStep = formStep.activeStep;
	const lastStep = formStep.lastStep;

	const url = new URL(currentUrl);

	// Create a URLSearchParams object from the query string
	const params = new URLSearchParams(url.search);

	// The parameter you want to check
	const paramName = 'page_status';

	// Check if the parameter exists
	if (params.has(paramName)) {
		const paramValue = params.get(paramName);
		if (paramValue === 'ok_page' && activeStep === lastStep){
			finishRegistration();
			setActiveStep(nextStep());
		}

		if (paramValue === 'fail_page' && activeStep === lastStep){
			failPayment.value = true;
		}
	}
}

checkForSuccessPayment();

watch(values, (newValues) => {
	setFormValues(newValues);
});

provide('form', { defineField, resetForm, validate })
</script>

<template>
	<div class="section-steps">
		<div class="section__shell">
			<div class="section__container">
				<div class="section__content">
					<form class="form-steps" @submit="onSubmit" @keydown.enter="$event.preventDefault()">
						<slot />
					</form>
				</div><!-- /.section__content -->

				<div class="section__image"></div><!-- /.section__image -->
			</div><!-- /.section__container -->
		</div><!-- /.section__shell -->
	</div><!-- /.section-steps -->
</template>
